import React from "react";

const ListingDetails = (props) => {
  let listing,
    address,
    listFees,
    listRental,
    shrinkDescription,
    cutDescription,
    URL,
    globalPropertID;
  listing = props.listing;

  const url = () => {
    if (
      listing.status &&
      ["rented", "sold"].includes(listing.status.toLowerCase())
    ) {
      return `sothebysrealty.com/eng/sold/detail/180-l-85298-${listing.listingNumber}`.toUpperCase();
    }
    return listing.rfgid
      ? `SOTHEBYSREALTY.COM/id/` + listing.rfgid.toUpperCase()
      : listing.mls
      ? `SOTHEBYSREALTY.COM/id/` + listing.mls.toUpperCase()
      : "";
  };

  URL = listing.vanityDomain ? listing.vanityDomain.toUpperCase() : url();

  address = listing.showAddress ? (
    <div className="main-print-headline">
      {listing.title + " | "}
      {listing.address2 && listing.address2 !== " "
        ? listing.address2 + " | "
        : null}
      {listing.cityStateZip}
    </div>
  ) : (
    <div className="main-print-headline">{listing.cityStateZip}</div>
  );

  listFees = () => {
    if (
      listing.listingFees === null ||
      typeof listing.listingFees === "undefined"
    ) {
      return <ul></ul>;
    }

    let listItems = listing.listingFees.map((f, i) => (
      <li key={i}>
        {" "}
        | <div className="bold-prefix">{f.prefix}</div>
        {f.displayPrice}
      </li>
    ));

    return (
      <ul className="print-fees-list">
        <li className="bold-prefix">{listing.price}</li>
        {listItems}
      </ul>
    );
  };

  listRental = () => {
    if (
      listing.rentalPrices === null ||
      typeof listing.rentalPrices === "undefined"
    ) {
      return <ul></ul>;
    }

    let rentalItem = listing.rentalPrices.map((f, i) =>
      i === 0 ? (
        <li key={i}>
          <div className="bold-prefix">{f.label}:</div> {f.price}
        </li>
      ) : (
        <li key={i}>
          {" "}
          | <div className="bold-prefix">{f.label}:</div> {f.price}
        </li>
      )
    );

    return <ul className="print-fees-list">{rentalItem}</ul>;
  };

  cutDescription = () => {
    if (props.listing.flyerCopy && props.listing.flyerCopy.length) {
      return props.listing.flyerCopy;
    }

    if (!listing.description) return "";

    let splitDescription = listing.description.match(
      /[^\.!\?]+[\.!\?]+["']?|$/g
    ); //split description into sentences
    let totalChars;

    if (listing.description.length > 2000) {
      do {
        totalChars = splitDescription.reduce((accu, currValue, i, array) => {
          return accu + currValue.length;
        }, 0);
        splitDescription.pop();
      } while (totalChars > 2000);
      return splitDescription.join("") + `\u00A0\u00A0... more on ${URL}`;
    } else {
      return listing.description;
    }
  };

  globalPropertID = listing.propertyID;

  shrinkDescription =
    listing.description && listing.description.length > 1600
      ? "shrinkDescription"
      : "";

  return (
    <div>
      <div className="main-print-details">
        <div className="main-print-title">
          {listing.showAddress ? listing.address1 : listing.title}
        </div>
        {address}
        <div className="main-print-fees">
          <ul className="print-fees-list">
            {listing.listingNumber ? (
              <li className="bold-prefix">Web ID: </li>
            ) : (
              ""
            )}
            <li>{listing.listingNumber}</li>
            {listing.source === "global" ? (
              <li className="bold-prefix">Property ID: </li>
            ) : (
              ""
            )}
            {listing.source === "global" ? <li>{globalPropertID} </li> : ""}
            {listing.listingNumber ||
            (listing.source === "global" && listing.mls) ? (
              <li> | </li>
            ) : (
              ""
            )}
            {listing.mls ? <li className="bold-prefix">MLS ID: </li> : ""}
            {listing.mls ? <li>{listing.mls}</li> : ""}
          </ul>
          {listFees()}
          {listRental()}
        </div>
      </div>
      <div className="print-view-spacer">
        <hr className="left"></hr>
      </div>
      <div
        className={`print-description-copy ${shrinkDescription}`}
        dangerouslySetInnerHTML={{ __html: cutDescription() }}></div>
      <div className="print-view-spacer">
        <hr className="right"></hr>
      </div>
      <div className="print-vanity-website">{URL}</div>
    </div>
  );
};

export default ListingDetails;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/listingdetails.js